import { Chip, Stack } from "@mui/material";
import type { TodoAssignmentCounts } from "../../api";

/**
 * Per-role links under a To Do item: one chip per role that has any of this
 * item's conversations, linking to the item's own search filtered to that
 * role. Roles at zero get no chip, so a role can be cleared in one pass.
 */
export const TodoRoleChips = ({
	counts,
	kind,
	baseUrl,
}: {
	counts: TodoAssignmentCounts;
	kind: "responses" | "stale";
	baseUrl: string;
}) => (
	<Stack
		direction="row"
		flexWrap="wrap"
		gap={1}
		sx={{ mt: 1 }}
		data-component="todo-role-chips"
	>
		{Object.entries(counts)
			.filter(([, c]) => c[kind] > 0)
			.map(([assignmentId, c]) => (
				<Chip
					key={assignmentId}
					data-component="todo-role-chip"
					size="small"
					clickable
					component="a"
					href={`${baseUrl}&responded_assignment=${assignmentId}`}
					label={`${c.name} (${c[kind]})`}
				/>
			))}
	</Stack>
);
